import { fabric } from 'fabric';
import addIconSVG from '../../../assets/add-icon-button.svg';
import { FabricTextBox } from '../../../global-types';
import { CanvasDataTypes, getGroupedItemByName } from '../../../utils';

// TODO: Method needs to be refactor to move external dependencies up.

// The Add icon button is a 44x44px square with a centered icon
// Used to calculate positioning within the fabric.js group (where icon has originX: 'left')
const ADD_ICON_BUTTON_SIZE = 44;
type Point = { x: number; y: number };

type LineCoords = {
  bl: Point;
  br: Point;
  tl: Point;
  tr: Point;
};

export type PhotoTextZone = fabric.Group &
  FabricTextBox & {
    padding: number;
    lineCoords: LineCoords;
  };

export type AddPhotoTextZoneButtonProps = {
  zone: PhotoTextZone;
  currentCanvas: fabric.Canvas;
  label?: string;
};

/** This creates a button for a PhotoTextZone and returns a promise that resolves when the button is added to the photo zone button
 * */
export const addPhotoTextZoneButton = ({ zone, currentCanvas, label }: AddPhotoTextZoneButtonProps): Promise<void> => {
  return new Promise((resolve) => {
    const iconSize = Math.min(zone.width as number, zone.height as number, ADD_ICON_BUTTON_SIZE);

    fabric.Image.fromURL(
      addIconSVG,
      (addIcon) => {
        addIcon.set({ originX: 'left', originY: 'center', left: 0, top: 0 });

        const left = zone.left as number;
        const buttonGroup = new fabric.Group([addIcon], {
          evented: false,
          name: CanvasDataTypes.PhotoTextZoneButton,
          hoverCursor: 'pointer',
          selectable: false,
          originX: 'center',
          originY: 'center',
          height: zone.height,
          left,
          top: zone.top,
          angle: zone.angle,
          data: {
            linkedZoneName: zone.name,
          },
          objectCaching: false,
        });
        document.fonts.ready.then(() => {
          const groupedItem = getGroupedItemByName(CanvasDataTypes.PhotoZoneTextbox, zone);
          const originalText = groupedItem instanceof fabric.Textbox ? groupedItem : undefined;
          if (!originalText) {
            zone.addWithUpdate(buttonGroup);
            resolve();
            return;
          }
          if (originalText.text && originalText.text.length > 0) {
            buttonGroup.visible = false;
            originalText.moveTo(0);
          } else {
            originalText.visible = false;
            buttonGroup.moveTo(0);
          }
          zone.addWithUpdate(buttonGroup);
          resolve();
        });
      },
      { width: iconSize, height: iconSize },
    );
  });
};
